export class EnumItem {
  code: string;
  label: string;
}
